import $ from "../vendor/jquery-3.6.0"

window.$ = $
window.jQuery = $
